export const THEME_ATTRIBUTE = "data-theme";
export const THEME_SELECTOR = "html";
